var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AutocompleteBase',_vm._g(_vm._b({attrs:{"items":_vm.authorizedAssigneeList,"itemText":"name","placeholder":"Select an assignee"},model:{value:(_vm.selectedAssignee),callback:function ($$v) {_vm.selectedAssignee=$$v},expression:"selectedAssignee"}},'AutocompleteBase',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }